module.exports = __webpack_public_path__ + "public/img/country_austria.10086002.svg";